package views.password

import androidx.compose.runtime.*
import ffButton0
import ffOption
import kotlinx.dom.clear
import org.jetbrains.compose.web.renderComposable
import kotlinx.browser.document
import kotlinx.browser.window
import model.*
import ffMsgAviso
import ffSpan
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.*
import testes.TestaZuza
import utils.*
import utils.ff.Companion.gbLogon
import utils.ff.Companion.gsAdmRet
import utils.ff.Companion.gsBrowser
import utils.ff.Companion.gsDesenvolvedor
import utils.ff.Companion.gsDom1
import utils.ff.Companion.gsDom2
import utils.ff.Companion.gsUrlLogon
import utils.ff.Companion.gsUsuSenhaTemp
import utils.ff.Companion.gsUsuarioTemp
import utils.ff.Companion.gsVersao
import utils.ff.Companion.println0
import utils.ff.Companion.println0Dy
import views.componentes.*

class password {

    private val _t = "password"
    private var origem = ""
    private var gsUsuario = ""
    private var gsSenha = ""

    //private var txUsuario: HTMLInputElement? = null
    //private var txSenha: HTMLInputElement? = null

    //private var _seSelect: HTMLSelectElement? = null
    private var lemp5: List<Empresa>? = null

    fun show(_origem: String) {
        origem = _origem

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
            //if (lemp5 != null && lemp5!!.count() > 0)
            //body1(lemp5!!)
        }
    }

    @Composable
    fun body() {

        gsDom1 = ""
        gsDom2 = ""
        gsUrlLogon = window.location.href
        println("gsUrlLogon = $gsUrlLogon")

        Div() {
            val _usuario = remember { mutableStateOf(gsInput(_t, _id = "_usuario", _focus = "true")) }
            val _senha = remember { mutableStateOf(gsInput(_t, _id = "_senha")) }
            val _seOpcao = remember { mutableStateOf("") }

            println0(_seOpcao)
            //gsDesenvolvedor = "P"
            if (_seOpcao.equals("UC")) {
                _usuario.text("Estoque256", _atualizar = true)
            }

            Div(attrs = { classes("dlg-pad-top-5"); tabIndex(0) }) {

                ffInput1("E-mail", _usuario, "S", 100, 100, false)
                //txUsuario = _usuario.getHTMLInputElement()!!
                ffInput1("Senha", _senha, "PS", 100, 100, false)
                //txSenha = _senha.getHTMLInputElement()!!

                if (gsUrlLogon.contains("/pro/")) {
                    gsDesenvolvedor = "P"
                } else if (_senha.text().equals("") && _usuario.text().equals("")) {
                    gsDesenvolvedor = ""

                    //o carregamento do link pós identificação do usuário é feito no Main,
                    //pesquise deveria seguir para o coletor999
                    _usuario.text(gsUsuarioTemp, _atualizar = true)
                    _senha.text(gsUsuSenhaTemp, _atualizar = true)
                    println("alterando gsDesenvolvedor=$gsDesenvolvedor, _usuario=${_usuario.text()}")
                }

                Div(attrs = {
                    style {
                        if (gsDesenvolvedor.equals("P")) display(DisplayStyle.None) else display(DisplayStyle.Block)
                    };
                }) {
                    ffCombo1Simples(
                        _span = "Opção",
                        _values = ff().reconheceEntrada(""),
                        _opcao = _seOpcao,
                        _width = 100,
                        _classes = "",
                        _esp = false,
                        _onFocusOut = {
                            println0("teste do evendo onExit")
                            _usuario.text("")
                            _senha.text("")
                            ff().reconheceEntrada(_seOpcao.value)

                            //_usuario.getHTMLInputElement()!!.value = ""
                            //mensagem("password", _usuario.getHTMLInputElement()!!.value)
                            //mensagem("password", _usuario.text())
                        }
                    )
                    if (!gsDesenvolvedor.equals("P") && gsDesenvolvedor.equals("")) {
                        gsDesenvolvedor = _seOpcao.value
                        ff().reconheceEntrada(_seOpcao.value)
                    }
                    //println("select = " + _seOpcao.value)
                }

                Div(attrs = { classes("form-group") }) {
                    ffButton0("Conectar", {
                        clickConectar(_usuario.text(), _senha.text(), _seOpcao.value) { b ->


                            //_senha.setFocus()
                            println0("executa getlogonDlogicaInicial gsDesenvolvedor=$gsDesenvolvedor _seOpcao=${_seOpcao.value}")
                            if (gsDesenvolvedor.equals("P")) {
                                ff().reconheceEntrada("P")
                            } else {
                                ff().reconheceEntrada(_seOpcao.value)
                                gsDesenvolvedor = _seOpcao.value
                            }
                            gsUsuario = _usuario.text()
                            gsSenha = _senha.text()
                            println0("vai setar o usuário = $gsUsuario")

                            renderComposable(rootElementId = "body1") {
                                body1(_seOpcao, b!!)
                            }
                        }
                    }, 100)
                }

                Div({ classes("input-group-append") }) {
                    ffSpan("vr.: $gsVersao $gsBrowser", _align = "right", _width = 100)
                }

                val sTeste: String = js("document.URL").toString()
                if (sTeste.contains("localhost") || sTeste.contains("dlgestoque.ddns.net") || sTeste.contains("dlogica.ddns.net")) {

                    Div(attrs = { id("body1"); classes("form-group") }) {

                        ffButton0("Acesso visitante", {

                            var sUrl = ""
                            sUrl =
                                "http://dlogica.ddns.net:8080/hom/000/web/index.html?obj={%22EMPRESA2%22:%221%22,%22LOGON%22:%22Visitante22%22,%22SENHA%22:%22123456%22,%22OBS%22:%22ok%22,%22CHAVE%22:%22eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGllbnRlIjoxMTI3LCJlbXBDbGllbnRlIjoxMTI3LCJ2YXJpYXZlbCI6IiIsImNvbnRhdG8iOjAsInRpcG9TZWd1cmFuY2EiOiJmdW4iLCJlbWFpbCI6ImVzdG9xdWVAZ3JhbmFkb2Rpc3RyaWJ1aWRvcmEuY29tLmJyIiwiYWRtaW4iOmZhbHNlLCJleHBpcmFjYW8iOiIyMDI0LTEyLTAyIiwiZW1wU2VyaWUiOiIyMiIsImVtcHJlc2EiOiIxIiwiY2hhdmUiOiIifQ==.50iMw/JC+u/6q1Pzw7VIuIjo29RLSMA0np5JVXFn8dU=%22,%22EMPRESA%22:{%22ID_EMPRESA%22:1,%22EMP_NOME%22:%22DLOGICA*SOFTWARE%22,%22EMP_CNPJ%22:%2205695673000199%22,%22EMP_FTPHOST%22:%22dlogica.com.br\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$%22,%22EMP_FONE%22:%2215\$3234-3223\$\$\$%22,%22EMP_CLIENTE%22:1127,%22EMP_SUBDOMVAREJ%22:%22loja%22,%22EMP_NRSERIE%22:22,%22EMP_EMAILOPCAO%22:%22D%22,%22EMP_BANVERSAO%22:%2219.11.04%22,%22EMP_WEBVERSAO%22:%22217%22,%22EMP_CONFQTNOTAOK%22:%22N%22,%22EMP_SERVERFTP%22:%221%22,%22EMP_SERVERAUX%22:1,%22EMP_COLDIGPROD%22:%22NS%22,%22EMP_CONFCEGAS%22:%22S%22,%22EMP_NOMECURTO00%22:%22DLOGICA%22,%22EMP_URLPRO00%22:%22https://dlgestoque.ddns.net:8181/droot/05695673000127_GRANADO/imagens/img_pro/%22,%22DTATUALIZADO00%22:%222024-12-02T18:24:28.177Z%22,%22EMP_WEBVERSAO%22:%22217%22},%22FUNC_FUNCAO%22:%22F%22,%22FUNC_NOME%22:%22VISITANTE*-*CONFERENCIA%22,%22FUNC_TRANSPDOM00%22:%22http:!!dlogica.ddns.net:8080!AdmRet-1!res%22,%22FUNC_URLLOGON%22:%22http://dlogica.ddns.net:8080/hom/137/web/index.html%22,%22ID_FUNCIONARIO%22:101,%22GSDESENVOLVEDOR%22:%22D2%22,%22GSCANVIEW%22:%22main/kotlin/views/%22,%22GSLOGONSIS%22:%22COL%22,%22GSLOGONFOR%22:%22null%22,%22*stable_64%22:8}"
                            ffJavaScript("window.location='$sUrl';")
                        }, 100)

                    }
                }

                if (sTeste.contains("localhost")) {
                    ffButton0(
                        _text = "Testa Zuza",
                        _onclick =
                            {
                                TestaZuza().iniciar()
                            },
                        _width = 100
                    )
                }
            }
            //_usuario.setFocusSimples()
        }
        //msgAviso(gsBrowser) //navigator.appVersion
        console.log("versão = ${ff.gsVersao}, gsDesenvolverdor = $gsDesenvolvedor")
    }


    fun clickConectar(_usuario: String, _senha: String, _select: String, cb: (List<Empresa>?) -> Unit) {

        //      var lemp: List<Empresa>? = null

        //gbClick = true
        println(
            "zuza aqui 00, executa clickConectar, vai enviar ao backend universo = $_usuario senha = $_senha select = $_select , " +
                    "gsDesenvolvedor=$gsDesenvolvedor"
        )

        if (gbLogon) {
            println("Logon já feito")
        } else if (_usuario.equals("")) {
            ffMsgAviso("Informe o usuário")
        } else if (_senha.equals("")) {
            ffMsgAviso("Informe a senha")
        } else if (_usuario.lowercase().equals("user")) {
            val sUrl =
                "http://dlogica.ddns.net:8080/hom/000/web/index.html?obj={%22EMPRESA2%22:%221%22,%22LOGON%22:%22Visitante22%22,%22SENHA%22:%22123456%22,%22OBS%22:%22ok%22,%22CHAVE%22:%22eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGllbnRlIjoxMTI3LCJlbXBDbGllbnRlIjoxMTI3LCJ2YXJpYXZlbCI6IiIsImNvbnRhdG8iOjAsInRpcG9TZWd1cmFuY2EiOiJmdW4iLCJlbWFpbCI6ImVzdG9xdWVAZ3JhbmFkb2Rpc3RyaWJ1aWRvcmEuY29tLmJyIiwiYWRtaW4iOmZhbHNlLCJleHBpcmFjYW8iOiIyMDI0LTEyLTAyIiwiZW1wU2VyaWUiOiIyMiIsImVtcHJlc2EiOiIxIiwiY2hhdmUiOiIifQ==.50iMw/JC+u/6q1Pzw7VIuIjo29RLSMA0np5JVXFn8dU=%22,%22EMPRESA%22:{%22ID_EMPRESA%22:1,%22EMP_NOME%22:%22DLOGICA*SOFTWARE%22,%22EMP_CNPJ%22:%2205695673000199%22,%22EMP_FTPHOST%22:%22dlogica.com.br\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$\$%22,%22EMP_FONE%22:%2215\$3234-3223\$\$\$%22,%22EMP_CLIENTE%22:1127,%22EMP_SUBDOMVAREJ%22:%22loja%22,%22EMP_NRSERIE%22:22,%22EMP_EMAILOPCAO%22:%22D%22,%22EMP_BANVERSAO%22:%2219.11.04%22,%22EMP_WEBVERSAO%22:%22217%22,%22EMP_CONFQTNOTAOK%22:%22N%22,%22EMP_SERVERFTP%22:%221%22,%22EMP_SERVERAUX%22:1,%22EMP_COLDIGPROD%22:%22NS%22,%22EMP_CONFCEGAS%22:%22S%22,%22EMP_NOMECURTO00%22:%22DLOGICA%22,%22EMP_URLPRO00%22:%22https://dlgestoque.ddns.net:8181/droot/05695673000127_GRANADO/imagens/img_pro/%22,%22DTATUALIZADO00%22:%222024-12-02T18:24:28.177Z%22,%22EMP_WEBVERSAO%22:%22217%22},%22FUNC_FUNCAO%22:%22F%22,%22FUNC_NOME%22:%22VISITANTE*-*CONFERENCIA%22,%22FUNC_TRANSPDOM00%22:%22http:!!dlogica.ddns.net:8080!AdmRet-1!res%22,%22FUNC_URLLOGON%22:%22http://dlogica.ddns.net:8080/hom/137/web/index.html%22,%22ID_FUNCIONARIO%22:101,%22GSDESENVOLVEDOR%22:%22D2%22,%22GSCANVIEW%22:%22main/kotlin/views/%22,%22GSLOGONSIS%22:%22COL%22,%22GSLOGONFOR%22:%22null%22,%22*stable_64%22:8}"
            ffJavaScript("window.location='$sUrl';")

        } else {

            //println0("zuza aqui 142 " + ff.gsUniverso)
            val lemp = ArrayList<Empresa>()

            ff.gsAcesso = "falha"
            println("entrou em novo dominio")

            Service().getLogon(
                _usuario,
                _senha,

                ) { a ->
                if (ff.gsAcesso.equals("ok")) {
                    //txUsuario!!.disabled = true
                    //txSenha!!.disabled = true

                    ffMsgAviso("")
                    //viewEntrar()
                    if (!ff.gsDom1.equals("")) {
                        println("zuza aqui 143 " + ff.gsDom1)
                        Service().getEmpresas02() { lemp1 ->
                            if (lemp1.size > 0) {
                                //busca as multiplas empresas ao qual o usuário tem acesso
                                println0("vai procurar o logon de multiplos-usuários")
                            }

                            if ((ff.gsDom1.equals(ff.gsDom2)) && (lemp1.size > 0)) {
                                Service().getLogonMulti(_usuario, _senha) { lEmp00 ->
                                    println0Dy(lEmp00)
                                    ff.gsDom2 = "acessado"

                                    //gsUrlLocal = lEmp00.get(0)
                                    //ffJavaScript("window.location='$sUrl';")
                                    println("zuza aqui gsAcesso = ${ff.gsAcesso}")
                                    if (ff.gsAcesso.equals("Passou") && lEmp00 != null) {
                                        //ff.println0("tbLista chegou ao acesso")
                                        //se o mod2 diferente de vazio entendo que tem mai de uma opção para logon
                                        if (lEmp00.get(0).aaGenericoEmpMod!!.mod2.equals(""))
                                            preenchetbLista(lEmp00)
                                    }
                                    println("finalizado clickConectar")

                                    cb(lemp1)
                                }
                            } else {
                                ffMsgAviso("Inatividade")
                            }

                        }
                    }

                } else {
                    ffMsgAviso("Usuário ou senha inválidos")
                }
            }


        }
        //    return true
    }


    @Composable
    fun body1(_seOpcao: MutableState<String>, lemp5: List<Empresa>) {

        val body1 = document.getElementById("body1") as HTMLDivElement
        body1.clear()

        var _seEmp by remember { mutableStateOf("1") }

        Div(attrs = { classes("form-group") }) {
            Span { Text("Empresa") }

            Select(attrs = {
                id("_seSelect")
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput { _seEmp = it.value!! }
                onChange {
                    _seEmp = it.value!!
                    //println0("aqui " + _seEmp)
                }
            }
            ) {
                //colocar as reais opções
                if (lemp5 != null && lemp5!!.count() > 0) {
                    for (obj in lemp5!!) {
                        ffOption(obj.ID_EMPRESA.toString(), obj.EMP_NOME)
                    }
                }
            }
        }

        Div(attrs = { classes("form-group") }) {
            ffButton0("Entrar", { _entrar ->
                clickEntrar(_seOpcao, _seEmp, aaGenericoEmp())
            }, 100)

            /*
            Button(attrs = {
                classes("btn", "dlg-mobbt100");
                onClick { _entrar ->
                clickEntrar(_seEmp, aaGenericoEmp())
            }
            }
            ) {
                Text("Entrar")
            }

             */
        }

        A(attrs = { id("linkTeste") }) { Text("") }
    }

    fun preenchetbLista(lemp: Array<aaGenericoEmp>) {

        println0("executa preenchetbLista")
        //var lemp = _lemp.toMutableList()

        println0(lemp)
        if (lemp.size > 0) {
            //divEmpresa.style.display = "block"
        }
        println0("executa preenchetbLista 01 " + lemp.size)

        //ff.println0(lemp)
        //ff.println0("tbLista chegou ao preenchetbLista 0 ${lemp.size}")

        val lemp1 = ArrayList<aaGenericoEmp>()
        for (obj1 in lemp) {
            println0("executa preenchetbLista 02")

            //ff.println0("tbLista chegou ao preenchetbLista 1")
            var iMod = 0
            var sMod1: String = "A"

            //ff.println0(obj)
            while (!sMod1.equals("")) {
                println0("executa preenchetbLista 03")
                var obj = aaGenericoEmp()
                obj.idGenEmpresa = obj1.idGenEmpresa
                obj.G01__ID = obj1.G01__ID
                obj.aaGenNome = obj1.aaGenNome
                obj.aaGenUrl = obj1.aaGenUrl
                obj.aaDom2 = obj1.aaDom2
                obj.mod00 = "Teste"
                obj.aaGenericoEmpMod = obj1.aaGenericoEmpMod

                if (!ff.gsDesenvolvedor.equals("P")) {
                    if (obj.aaGenNome.contains("GRANADO DISTRIBUIDORA")) {
                        obj.aaGenUrl = "http://dlogica.ddns.net:8080/AdmRet-1/res"
                    } else {
                        obj.aaGenUrl = "http://dlogica.ddns.net:8080/AdmRetGD/res"
                    }
                }
                println0("executa preenchetbLista 04 ${obj.aaGenUrl}")

                iMod = iMod + 1

                when (iMod) {
                    1 -> sMod1 = obj.aaGenericoEmpMod!!.mod1.ffVss()
                    2 -> sMod1 = obj.aaGenericoEmpMod!!.mod2.ffVss()
                    3 -> sMod1 = obj.aaGenericoEmpMod!!.mod3.ffVss()
                    4 -> sMod1 = obj.aaGenericoEmpMod!!.mod4.ffVss()
                    5 -> sMod1 = obj.aaGenericoEmpMod!!.mod5.ffVss()
                    6 -> sMod1 = obj.aaGenericoEmpMod!!.mod6.ffVss()
                    7 -> sMod1 = obj.aaGenericoEmpMod!!.mod7.ffVss()
                    else -> sMod1 = "RET"
                }

                //println0("inicio println0 $sMod1")
                //sMod1 = sMod1.ffVss()
                //println0("tLinha = ${obj.mod00} lenght = ${sMod1.length} valor = $sMod1")
                obj.mod00 = sMod1

//                if (iMod > 3) {
//                    println0("previu $iMod")
//                    sMod1 = ""
//                }
                if (!sMod1.equals("")) {
                    lemp1.add(obj)
                }
            }
        }

        //println("tLinha vai imprimir o lemp1")
        println0("lemp1 " + lemp1.size)
        for (obj1 in lemp1) {
            //para ambiente de teste de fabricantes muda a URL
            //var tLinha = ff().tbGridNovaLinha1(tbLista, 4, true, "",
            /*
            var tLinha = ff().tbGridNovaLinha(
                tbLista, 3,
                "|00-" +
                        "|01${obj1.aaGenNome}" +
                        "|02${obj1.mod00}" +
                        "|03${obj1.aaGenUrl}"
            )

             */

            //ff.println0("tLinha ${obj1.mod00}")
            //tLinha.onclick = { clickEntrar(sMod) }
            println("invocando clickEntrar no Password ${obj1.aaGenUrl}")
            //tLinha.onclick = { clickEntrar(obj1) }
            //ff.println0("tLinha1 $sMod")
        }
    }

    //fun clickEntrar(block: DIV.() -> Unit) {
    fun clickEntrar(_seOpcao: MutableState<String>, _empresa: String, preSet1: aaGenericoEmp) {
        var preSet = ""
        //ff.println0(preSet1!!)
        preSet = preSet1!!.mod00
        println("executando clickEntrar99 preset = ${preSet1!!.mod00}")
        println("gsDesenvolvedor ${ff.gsDesenvolvedor} ${preSet} _seOpcao = $_seOpcao")


        ff.gsAcesso = " falha"

        val oLog = Logon.AdmRet()
        oLog.EMPRESA2 = _empresa
        oLog.LOGON = gsUsuario
        oLog.SENHA = gsSenha

        println("zuza usuario = $gsUsuario")
        println(oLog)
        println0Dy(oLog)
        //Service().postGen(oNota!!.asDynamic(), "${ff.gsDom1}/notas/016/qtvolumes") { objReturn ->
        //Service().postLogonAdm(oLog) { lista ->
        Service().postLogonAdmRet(oLog!!.asDynamic(), "logon/004/funcionarioLogon") { lista ->

            //println0(lista)
            val objL = lista.getOrNull(0)
            println0("vai imprimir o objeto")
            println0Dy(objL)

            if (objL != null && objL.OBS.equals("ok")) {
                objL.EMPRESA2 = oLog.EMPRESA2
                objL.LOGON = oLog.LOGON
                objL.SENHA = oLog.SENHA

                ff.gsToken = objL.CHAVE
                objL.LOGON = oLog.LOGON

                var sUrl = js("document.URL").toString()
                if (!_seOpcao.equals("P") && (sUrl.contains("dlgestoque.ddns.net/hom/")))
                    sUrl = sUrl.replace("dlgestoque.ddns.net/hom/", "dlogica.ddns.net:8080/hom/")


//                if (sUrl.contains("localhost"))
//                    sUrl = sUrl.replace(":8080/", ":63342/dlg/dlg.dlgw_logon/src/index.html")
//                if (sUrl.contains("/hom/"))
//                    sUrl = sUrl.replace("/hom/000/index.html", "/hom/000/dlg/dlgw_logon/web/index.html")
//                else if (sUrl.contains("/pro/"))
//                    sUrl = sUrl.replace("/pro/000/index.html", "/pro/000/dlg/dlgw_logon/web/index.html")
                objL.FUNC_URLLOGON = sUrl
                objL.FUNC_URLLOGON = objL.FUNC_URLLOGON.replace("/000", "/137")
                objL.EMP_URLPRO00 = oLog.EMP_URLPRO00
                objL.OO_ADMRET = gsAdmRet

                //println0("zuza998")
                println0(sUrl)

                val ola: String = "[" + JSON.stringify(objL.EMPRESA) + "]"
                println0(ola)
                ff.goEMPRESA = Empresa().construtorLista(ola).get(0)
                println0(ff.goEMPRESA)
                //ff.goEMPRESA.EMP_URLPRO00 = oLog.EMP_URLPRO00
                //ff.goEMPRESA.EMP_NOME = "EDUARDO"

                //println("$sUrl")
                sUrl = sUrl.replace("/000", "/***")
                println("preset $preSet novamente ${objL.FUNC_FUNCAO} URL base $sUrl")

                if (preSet.equals("")) {
                    if (objL.FUNC_FUNCAO.equals("E") //externo dlgw_representante
                        || objL.FUNC_FUNCAO.equals("G") //gerente
                        || objL.FUNC_FUNCAO.equals("S")
                    ) { //supervisor
                        sUrl = sUrl.replace("dlgw_logon", "dlgw_representante")
                        preSet = "REP"
                    } else if (objL.FUNC_FUNCAO.equals("F")) { //funcionario dlgw_coletor
                        sUrl = sUrl.replace("dlgw_logon", "dlgw_coletor")
                        //sUrl = sUrl.replace("desenv.intellij.dlg.dlgw_logon~1", "desenv-intellij-dlg-dlgw_coletor~1")
                        preSet = "COL"
                    } else if (objL.FUNC_FUNCAO.equals("B")) {
                        sUrl = sUrl.replace("dlgw_logon", "dlgw_producao")
                        preSet = "PRO"
                    }
                } else {
                    sUrl = sUrl.replace("dlgw_logon", "dlgw_retaguarda")
                    //sUrl = sUrl.replace(".dlgw_logon", ".dlgw_retaguarda")
                }

                //println("preset $preSet novamente01 urlBase ${sUrl}")
                //println("$sUrl")
                objL.FUNC_TRANSPDOM00 = ff.gsDom1.replace("/", "!")
                objL.GSDESENVOLVEDOR = ff.gsDesenvolvedor
                objL.GSCANVIEW = ff.gsCamView
                objL.GSLOGONSIS = preSet
                //obj.emp
                //println0(ff.gsFuncao)
                val sTeste = JSON.stringify(objL).ffJsonParse(true).replace("\"", "%22").replace(" ", "$")
//                println0(objL)
//                println0("zuza123")
                //println0(sTeste)
                //println0("zuza1234")
                //println0(JSON.stringify(objL))

                sUrl = sUrl.replace("$", "AdmRet") //não sei se faz diferença
                sUrl = sUrl + "?obj=${sTeste}"
                //println("aqui zuza 99 $sUrl")
                println("EMP_WEBVERSAO = ${objL.EMPRESA!!.EMP_WEBVERSAO} AMBIENTE = ${objL.GSDESENVOLVEDOR}")

                val linkTeste = document.getElementById("linkTeste") as HTMLAnchorElement
                println0("capturou o linkTeste gsDesenvolvedor=$gsDesenvolvedor _seOpcao=${_seOpcao.value}")
                if (!gsDesenvolvedor.equals("P")) {
                    gsDesenvolvedor = _seOpcao.value
                    ff().reconheceEntrada(_seOpcao.value)
                }

                val oemp = Empresa()
                ff.giEmpresa = oLog.EMPRESA2.ffVsi()
                ff.goFUNCIONARIO.ID_FUNCIONARIO = objL.ID_FUNCIONARIO
                //ff.goFUNCIONARIO.FUNC_EMPRESA = objL.EMPRESA!!.ID_EMPRESA
                ff.goFUNCIONARIO.FUNC_NOME = objL.FUNC_NOME
                ff.goFUNCIONARIO.FUNC_FUNCAO = objL.FUNC_FUNCAO
                ff.goFUNCIONARIO.FUNC_LOGON = objL.LOGON
                if (gsDesenvolvedor.equals("P"))
                    ff.goFUNCIONARIO.FUNC_TRANSPDOM00 = objL.FUNC_TRANSPDOM00.replace("!", "/")
                else
                    ff.goFUNCIONARIO.FUNC_TRANSPDOM00 = ff.gsDom1
                ff.goFUNCIONARIO.PRO_CODIGO00 = objL.PRO_CODIGO.ffVsi()
                ff.goFUNCIONARIO.CLI_CODIGO00 = objL.CLI_CODIGO.ffVsi()
                //println0(ff.goFUNCIONARIO)
                //println0(ff.giEmpresa)
                //println0(oLog.EMPRESA2)

                //if (sUrl.contains("representante")) {
                //    principalREP().show()
                //} else if (!objL.GSDESENVOLVEDOR.equals("P")) {
                //    principalCOL().show()
                //} else

                sUrl = sUrl.replace("/999/", "/***/")
                if (sUrl.contains("localhost:") || sUrl.contains("10.10.1.177:8080") || sUrl.contains("dlogica.ddns.net:8787")) {  //|| sUrl.contains("dlogica.ddns.net:8080")) { //|| (sUrl.contains("/hom/"))) {

                    if (sUrl.contains("localhost:"))
                        sUrl = sUrl.replace("dlg/dlgw_", "dlg.dlgw_")
                    sUrl = sUrl.replace("/***/", "/${objL.EMPRESA!!.EMP_WEBVERSAO}/")
                    //println("teste zuza1")
                    //sUrl = sUrl.replace("/***/", "/${goEMPRESA.EMP_WEBVERSAO}/")
                    linkTeste!!.innerText = sUrl
                    linkTeste!!.href = sUrl
                    //ffJavaScript("window.location='$sUrl';")
                } else {

                    println("zuza999")
                    println("versao=${objL.EMPRESA!!.EMP_WEBVERSAO}")
                    println("versao=${objL.EMPRESA!!.EMP_WEBVERSAO}")
                    println(sUrl)

                    sUrl = sUrl.replace("/***", "/${objL.EMPRESA!!.EMP_WEBVERSAO}")
                    //if (objL.EMPRESA!!.EMP_WEBVERSAO.ffVsi() < 138)
                    //sUrl = sUrl.replace("web/index.html", "dlg/dlgw_logon/web/index.html")
                    //sUrl = sUrl.replace("/***", "/999")

                    if (sUrl.contains("/pro/"))
                        objL.GSDESENVOLVEDOR = "P"

                    //console.log(objL)
                    linkTeste!!.innerText = sUrl
                    linkTeste!!.href = sUrl
                    ffJavaScript("window.location='$sUrl';")
                }
            } else {
                ffMsgAviso("Falha no logon, usuário não encontrado zuza")
            }
        }
    }
}

